import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentToken } from '../../actions/authSlice'
import { useRefreshMutation } from '../../api/authApiSlice'
import { Outlet } from 'react-router-dom'
import logomeka from '../../assets/logo.png'
import { Grid } from '@mui/material'
 
 const PersistLogin = () => {

    const persist = true
    const token = useSelector(selectCurrentToken)
    const effectRan = useRef(false)
    const [trueSuccess, setTrueSuccess] = useState(false)

    const [refresh, {
        isUninitialized,
        isLoading,
        isSuccess,
        isError,
    }] = useRefreshMutation()

    useEffect(() => {

        if (effectRan.current === true) return
        effectRan.current = true

        const verifyRefreshToken = async () => {
            try {
                await refresh()
                setTrueSuccess(true)
            }
            catch (err) {
                console.log(err)
            }
        }

        if (!token && persist) verifyRefreshToken()
      
        // eslint-disable-next-line
    }, [])
    
    let content = <Outlet />
    if (!persist) { // persist: no
        content = <Outlet />
    } else if (isLoading) { //persist: yes, token: no
        content = <Grid spacing={2} container sx={{width: '100%', height: '100%'}}>
            <Grid sx={{width: '100%', height: '97.5%', borderRadius: '16px', backgroundColor: '#08084f', backgroundImage: 'url('+logomeka+')', backgroundRepeat: 'no-repeat', backgroundSize: '20vw 20vw', backgroundPosition: 'center', m:2}}></Grid>    
        </Grid>
    } else if (isError) { //persist: yes, token: no
        content = <Outlet />
    } else if (isSuccess && trueSuccess) { //persist: yes, token: yes
        content = <Outlet />
    } else if (token && isUninitialized) { //persist: yes, token: yes
        content = <Outlet />
    }

    return content
 }
 
 export default PersistLogin